export default "/fonts/fa-v4compatibility.woff2?4ee7f902d88f819e251c9129d67419de";